const axios = require('axios');

import {
	serverUrl,
	presighnedUrl
} from '../properties'
const dataUrl = serverUrl;

export default {
	namespaced: true,
	state:{
		templateList:[],
		tokenList:[],
		tempOwner:'Me'
	},
	mutations:{
		setTemplateList:(state, data) => {
			state.templateList  = data;
		},
		setTokenList:(state, data) => {
			state.tokenList  = data;
		},
	},
	getters:{

	},
	actions:{
		saveTemplate: ({ commit, state, rootGetters, rootState }, payload) => {
			return new Promise((resolve, reject) => {
				payload.userName = JSON.parse(window.localStorage.session).name;

				axios({
					url: dataUrl + '/template/addEdit',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error)
					commit('hideLoadingSpinner', null, { root: true })
				})
			})
	   },
	   getTemplateList: ({ commit, state, rootGetters, rootState }, payload) => {
		   return new Promise((resolve, reject) => {


			   if(!payload){
				   if(state.tempOwner == 'Me'){
					   payload = {}
					   payload.tempOwner =  JSON.parse(window.localStorage.session).name;
					   payload.sort= rootState.selectedSortOrder
				   }
				   else{
					   payload = {
						   sort: rootState.selectedSortOrder
					   }
				   }
			   }

			   axios({
				   url: dataUrl + '/template/list',
				   method: 'POST',
				   headers: rootGetters.fetchHeader,
				   data: payload,
				   responseType: 'json'
			   }).then((response) => {
				   commit("setTemplateList", response.data)
				   resolve(response.data)
			   }).catch((error) => {
				   console.log(error)
				   commit('hideLoadingSpinner', null, { root: true })
			   })
		   })
	  },
	  getTemplate: ({ commit, state, rootGetters, rootState }, payload) => {
		  return new Promise((resolve, reject) => {
			  axios({
				  url: dataUrl + '/template/get',
				  method: 'POST',
				  headers: rootGetters.fetchHeader,
				  data: payload,
				  responseType: 'json'
			  }).then((response) => {
				  resolve(response.data)
			  }).catch((error) => {
				  console.log(error)
				  commit('hideLoadingSpinner', null, { root: true })
			  })
		  })
	 },
	 deleteTemplate: ({ commit, state, rootGetters, rootState }, payload) => {
		 return new Promise((resolve, reject) => {
			 axios({
				 url: dataUrl + '/template/del',
				 method: 'POST',
				 headers: rootGetters.fetchHeader,
				 data: payload,
				 responseType: 'json'
			 }).then((response) => {
				 resolve(response.data)
			 }).catch((error) => {
				 console.log(error)
				 commit('hideLoadingSpinner', null, { root: true })
			 })
		 })
	 },
	 getTokensList: ({ commit, state, rootGetters, rootState }, payload) => {
		 return new Promise((resolve, reject) => {
			 axios({
				 url: dataUrl + '/template/getGroupList',
				 method: 'POST',
				 headers: rootGetters.fetchHeader,
				 data: payload,
				 responseType: 'json'
			 }).then((response) => {
				 commit("setTokenList", response.data)
				 resolve(response.data)
			 }).catch((error) => {
				 console.log(error)
				 commit('hideLoadingSpinner', null, { root: true })
			 })
		 })
	 },
	 getTypeList: ({ commit, state, rootGetters, rootState }, payload) => {
		 return new Promise((resolve, reject) => {
			 axios({
				 url: dataUrl + '/template/type',
				 method: 'POST',
				 headers: rootGetters.fetchHeader,
				 responseType: 'json'
			 }).then((response) => {
				 resolve(response.data)
			 }).catch((error) => {
				 console.log(error)
				 commit('hideLoadingSpinner', null, { root: true })
			 })
		 })
	 },
   }
}
